export const SHOT_POLLING_SENTRY_FINGERPRINT =
  'SHOT_POLLING_SENTRY_FINGERPRINT';

export const LOG_LEVELS = {
  DEBUG: 'debug',
  ERROR: 'error',
  FATAL: 'fatal',
  INFO: 'info',
  WARNING: 'warning',
};

export const VALID_LOG_LEVELS = new Set(Object.values(LOG_LEVELS));
